import { render, staticRenderFns } from "./entryPart.vue?vue&type=template&id=58855f32&scoped=true"
import script from "./entryPart.vue?vue&type=script&lang=js"
export * from "./entryPart.vue?vue&type=script&lang=js"
import style0 from "./entryPart.vue?vue&type=style&index=0&id=58855f32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58855f32",
  null
  
)

export default component.exports